import { Routes } from '@angular/router';

import { calCanActivateGuard } from './core/guards/cal-auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./features/home/home.routes').then((m) => m.HOME_ROUTES),
    canActivate: [calCanActivateGuard],
  },
  {
    path: 'sign-in-failed',
    loadComponent: () =>
      import('./features/auth/sign-in-failure/sign-in-failure.component').then(
        (m) => m.SignInFailureComponent
      ),
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
